var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "362px",
    height: "524px",
    viewBox: "0 0 362 524",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9588057,367.883356 L0.835500582,8.46105637 C0.564058687,4.05112442 3.91896774,0.2561211 8.32889969,-0.0153207951 C11.1510518,-0.189031029 13.8552891,1.13988977 15.4419934,3.48020752 L359.901323,511.54229 C362.380728,515.199301 361.426089,520.17385 357.769078,522.653255 C355.449065,524.226192 352.475048,524.470198 349.929681,523.296445 L27.5936568,374.656662 C24.9200418,373.42377 23.1396852,370.821982 22.9588057,367.883356 Z",
    id: "Rectangle2",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle2);
export default __webpack_public_path__ + "static/media/Rectangle2.84f08783145f172a1a41fb8f1e177f1d.svg";
export { ForwardRef as ReactComponent };